//Pruebas IMASD 145 Pruebas
//export const serverMain = "https://201.46.92.145/Meditoc/Freemium/WS/";

//Pruebas Meditoc 360 Produccion
export const serverMain = "https://productos.meditoc.com/MeditocWSV2/";
//export const serverMain = "https://140.84.187.175/MeditocWSV2/";

//Pruebas Meditoc 360 Preproduccion
//export const serverMain = "https://productos.meditoc.com/PreProduccionWs/";

//Pruebas Meditoc 360 QA
//export const serverMain = "https://productos.meditoc.com/QAPreWs/";
//export const serverMain = "https://140.84.168.89/QAPreWs/";

//Local
//export const serverMain = "http://localhost/IMD.Meditoc.CallCenter.Mx.Web/";
